module.exports = __webpack_public_path__ + "img/ad.368b46be.svg";